(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("bizcharts"), require("react-dom"), require("DataSet"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "bizcharts", "react-dom", "DataSet"], factory);
	else if(typeof exports === 'object')
		exports["antd-pro-charts"] = factory(require("react"), require("bizcharts"), require("react-dom"), require("DataSet"));
	else
		root["antd-pro-charts"] = factory(root["React"], root["bizcharts"], root["ReactDOM"], root["DataSet"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__36__) {
return 